import { QuotationResponse } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import { matchRequestLoadingState } from "@/atoms/match/matchRequestLoadingState";
import { matchRequestResDataState } from "@/atoms/match/matchRequestResDataState";
import { quotationRequestState } from "@/atoms/quotationRequestState";
// import CustomRequestModalContent from "@/components/Match/CustomRequestModalContent";
import { temporaryMatchRequestState } from "@/containers/MatchContainer/atoms";
import {
  장례준비긴급도_LIST,
  조문객예상인원_LIST,
} from "@/containers/MatchContainer/constants/request";
// import { useCustomVariation } from "@/hooks/useCustomVariation";
import { useDialog } from "@/hooks/useDialog";
import { useSangjoQuotationRequestExistModal } from "@/hooks/useSangjoQuotationRequestExistModal";
import useSangjoQuotationRequests from "@/hooks/useSangjoQuotationRequests";
import { ParlorDetailProps } from "@/types/parlor";
import { Box, Button, HStack, VStack } from "@chakra-ui/react";
// import { useOverlay } from "@toss/use-overlay";
import { AxiosResponse } from "axios";
import {
  call,
  ColorIcon,
  colors,
  cooKeys,
  customEvent,
  Field,
  getCookie,
  HackleEventName,
  // OverlayModal,
  setCookie,
} from "goi_common";
import { Axios } from "@/utils/axios";
import { useRouter } from "next/router";
import { Dispatch, Reducer, useCallback, useMemo, useReducer, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import RequestUniqueFixedButton from "./RequestUniqueFixedButton";
import { useCustomVariation } from "@/hooks/useCustomVariation";

export default function ParlorRequestQuestionStepByStep({ parlor }: { parlor: ParlorDetailProps }) {
  const steps = useMemo(() => {
    return [
      {
        step: 1,
      },

      {
        step: 2,
      },

      {
        step: 3,
      },

      {
        step: 4,
      },
    ];
  }, []);
  const [currentStep, setCurrentStep] = useState(1);

  const variation = useCustomVariation(130);

  const stepTitle = useMemo(() => {
    const titles = [
      "원하시는 빈소 평형을 선택해주세요.",
      "예상 조문객 수를\n선택해주세요",
      "장례 준비 상황을\n 자세히 알려주세요",
    ];

    if (variation === "A") {
      return titles[currentStep - 1];
    } else {
      return [...titles].reverse()[currentStep - 1];
    }
  }, [currentStep, variation]);
  const { onOpenRequestExistModal } = useSangjoQuotationRequestExistModal();

  const [selectedOption, setSelectedOption] = useReducer<
    Reducer<SelectedOption, Partial<SelectedOption>>
  >(
    (prev, next) => {
      return { ...prev, ...next };
    },
    {
      장례준비긴급도: "",
      sido: Number(parlor.sido),
      sigungu: Number(parlor.sigungu),
      조문객수: "",
      평형: "",
    },
  );

  const isNextDisabled = useMemo(() => {
    if (currentStep === 1) {
      if (variation === "A") {
        return Boolean(!selectedOption.평형);
      } else {
        return Boolean(!selectedOption.장례준비긴급도);
      }
    } else if (currentStep === 2) {
      return !Boolean(selectedOption.조문객수);
    } else {
      if (variation === "A") {
        return Boolean(!selectedOption.장례준비긴급도);
      } else {
        return Boolean(!selectedOption.평형);
      }
    }
  }, [selectedOption, currentStep]);

  const [loading, setLoading] = useRecoilState(matchRequestLoadingState);
  const setResponseData = useSetRecoilState<any>(matchRequestResDataState);

  // const overlay = useOverlay();
  const { onOpen, onClose } = useDialog();
  const [, setTemporaryMatchRequest] = useRecoilState(temporaryMatchRequestState);

  const isLoggedIn = useRecoilValue(isLoggedInState);

  const setQuotationRequest = useSetRecoilState(quotationRequestState);
  const router = useRouter();
  const { setQuotationRequestCookie, mutateSangjoQuotation } = useSangjoQuotationRequests();

  // const variation = useCustomVariation(129);

  const handleSubmit = useCallback(async () => {
    if (loading) return;

    customEvent({
      newGtm: {
        path: "parlor_detail_request",
        trigger_and_target: "submit_conversion",
      },
    });

    if (isNextDisabled) {
      onOpen({
        type: 1,
        closeOnOverlayClick: false,
        header: "응답하지 않은 항목이 있어요",
        children: <>다시 확인해주세요.</>,
        footerProps: {
          text: "확인",
          onClick: onClose,
        },
      });
      return;
    }

    try {
      setLoading(true);

      const body = {
        status: selectedOption.장례준비긴급도,
        funeral_sido: selectedOption.sido,
        funeral_sigungu: selectedOption.sigungu,
        needs_binso: selectedOption.조문객수 === "0명(무빈소)" ? false : true,
        condolers:
          selectedOption.조문객수 === "없음"
            ? ""
            : selectedOption.조문객수 === "0명(무빈소)"
            ? "0명"
            : (selectedOption.조문객수 as string),
        is_sequential: false,
      };

      const onSuccess = ({ data }: AxiosResponse<QuotationResponse>) => {
        customEvent({
          newGtm: {
            action: "match_request_complete",
          },
          triggerHackle: true,
        });

        customEvent({
          newGtm: {
            action: "match_request_complete_parlor",
          },
          triggerHackle: true,
        });

        if (isLoggedIn) {
          // router.push(
          //   `/match/request-complete?id=${data.id}&sido=${data.funeral_sido}&sigungu=${data.funeral_sigungu}`,
          // );
        } else {
          setTemporaryMatchRequest(data.id);
          setResponseData(data);
          setQuotationRequest(data);
          setQuotationRequestCookie(data);

          const handleSangjoQuotationRequest = async () => {
            customEvent({
              newGtm: {
                path: "match_request",
                trigger_and_target: "mdl_check_result",
              },
              triggerHackle: true,
            });

            customEvent({
              newGtm: {
                path: "parlor_match_request",
                trigger_and_target: "mdl_check_result",
              },
              triggerHackle: true,
            });

            const anyMemo = getCookie("match_request_memo");
            const previousRequestedQuotation = getCookie(cooKeys.quotation_request);

            const 요청하고_싶은_점 =
              parlor.companyname +
              "개별 견적 페이지에서 제출한 견적 / 선택한 평형 : " +
              selectedOption.평형;

            const { data } = await Axios.patch(
              `/sangjo_quotation_requests/${previousRequestedQuotation.id}/`,
              {
                memo: 요청하고_싶은_점 + " | " + (anyMemo || ""),
              },
            );

            if (!isLoggedIn) {
              setCookie(
                cooKeys.quotation_request,
                JSON.stringify({ ...data, id: previousRequestedQuotation.id }),
              );

              setQuotationRequest(data);

              router.push(
                `/login?redirectTo=${encodeURIComponent(
                  `/match/request/`,
                )}${`&event_from=uv_parlor_mtch_rqst`}`,
              );
            } else {
              router.push(
                `/match/request-complete?id=${data.id}&sido=${data.funeral_sido}&sigungu=${data.funeral_sigungu}`,
              );
            }
          };

          handleSangjoQuotationRequest();
          // }
        }
      };

      mutateSangjoQuotation({
        body,
        onSuccess,
        onError: () => {
          setLoading(false);
        },
      });
    } catch (e: any) {
      if (e.response.status === 409) {
        onOpenRequestExistModal();
      }
      setLoading(false);
    }
  }, [selectedOption]);

  const handlePageLocation = () => {
    customEvent({
      newGtm: {
        path: "parlor_detail_request",
        trigger_and_target: "CTA",
      },
    });
    const path = { pathname: "/guidebook/", hash: "mainTab" };

    router.push(path);
  };

  if (variation === "Z") {
    return null;
  }

  return (
    <VStack px="16px">
      <HeaderLayout title={`${parlor.companyname}\n예상비용 알아보기`} />
      <StepIndicator steps={steps} currentStep={currentStep} />

      <Box pt="24px" width="100%" whiteSpace="pre-line" className="head2_b black">
        {stepTitle}
      </Box>
      <Box pt="24px" width="100%">
        <StepQuestion
          parlor={parlor}
          currentStep={currentStep}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          variation={variation}
        />
      </Box>
      <HStack pt="24px" width="100%" alignItems="center" justifyContent="space-between" gap="24px">
        <Box width="100%">
          <PrevNext
            disabled={currentStep <= 1}
            text="이전"
            onClick={() => setCurrentStep(currentStep - 1)}
          />
        </Box>
        <Box width="100%">
          {currentStep === 3 ? (
            <>
              <RequestUniqueFixedButton
                handleSubmit={handleSubmit}
                handlePageLocation={handlePageLocation}
                loading={loading}
                isTest
                disabled={isNextDisabled}
              />
            </>
          ) : (
            <PrevNext
              disabled={isNextDisabled}
              text="다음"
              onClick={() => {
                setCurrentStep(currentStep + 1);
              }}
            />
          )}
        </Box>
      </HStack>

      <Box pt="24px" pb="120px" width="100%">
        <StepQuestionExtraDetail currentStep={currentStep} variation={variation} />
      </Box>
    </VStack>
  );
}
const PrevNext = ({
  text,
  disabled,
  onClick,
}: {
  text: string;
  disabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <Button
      onClick={onClick}
      isDisabled={disabled}
      background={colors.orange650}
      color="white"
      _hover={{ background: colors.orange500 }}
      _disabled={{
        background: colors.orange400,
      }}
      borderRadius="36px"
      width="100%"
    >
      {text}
    </Button>
  );
};

export interface SelectedOption {
  장례준비긴급도: string;
  조문객수: string;
  평형: string;
  sido: number;
  sigungu: number;
}

const StepQuestion = ({
  currentStep,
  selectedOption,
  setSelectedOption,
  parlor,
  variation,
}: {
  currentStep: number;
  selectedOption: SelectedOption;
  setSelectedOption: Dispatch<Partial<SelectedOption>>;
  parlor: ParlorDetailProps;
  variation: string;
}) => {
  const 빈소평형_LIST = parlor.binsos
    .map((res, i) => {
      if (i === 4) {
        return `${res.pyeong}평 이상`;
      } else if (i < 5) {
        return `${res.pyeong}평`;
      } else {
        return;
      }
    })
    .filter((val, index, self) => val !== undefined && self.indexOf(val) === index)
    .concat(["잘 모르겠어요"]);

  if (variation === "A") {
    if (currentStep === 1) {
      return (
        <VStack width="100%" minWidth="100%">
          <Field.ButtonGroups
            items={빈소평형_LIST as string[]}
            value={selectedOption.평형}
            onChange={(e) => {
              setSelectedOption({ 평형: e });
              customEvent({
                newGtm: {
                  path: "parlor_detail_request",
                  trigger_and_target: "pyeong-answer",
                },
              });
            }}
            borderColor="white"
            buttonWidth="100%"
          />
        </VStack>
      );
    } else if (currentStep === 2) {
      return (
        <VStack width="100%">
          <Field.ButtonGroups
            items={조문객예상인원_LIST}
            value={selectedOption.조문객수}
            onChange={(e) => {
              setSelectedOption({ 조문객수: e });

              customEvent({
                newGtm: {
                  path: "parlor_match_request",
                  trigger_and_target: "condolers-answer",
                },
              });
              customEvent({
                hackle: {
                  key: HackleEventName["견적 요청 - 조문객 수 선택"],
                  properties: { name: String(e) },
                },
              });
            }}
            borderColor="white"
            buttonWidth="100%"
          />
        </VStack>
      );
    } else if (currentStep === 3) {
      return (
        <VStack width="100%">
          <Field.ButtonGroups
            items={장례준비긴급도_LIST}
            value={selectedOption.장례준비긴급도}
            onChange={(e) => {
              setSelectedOption({ 장례준비긴급도: e });

              customEvent({
                newGtm: {
                  path: "parlor_match_request",
                  trigger_and_target: "status-answer",
                },
              });
              customEvent({
                hackle: {
                  key: HackleEventName["견적 요청 - 장례준비긴급도 선택"],
                  properties: { name: e },
                },
              });
            }}
            buttonWidth="100%"
            borderColor="white"
          />
        </VStack>
      );
    }
  }

  if (variation === "B") {
    if (currentStep === 1) {
      return (
        <VStack width="100%">
          <Field.ButtonGroups
            items={장례준비긴급도_LIST}
            value={selectedOption.장례준비긴급도}
            onChange={(e) => {
              setSelectedOption({ 장례준비긴급도: e });

              customEvent({
                newGtm: {
                  path: "parlor_match_request",
                  trigger_and_target: "status-answer",
                },
              });
              customEvent({
                hackle: {
                  key: HackleEventName["견적 요청 - 장례준비긴급도 선택"],
                  properties: { name: e },
                },
              });
            }}
            buttonWidth="100%"
            borderColor="white"
          />
        </VStack>
      );
    } else if (currentStep === 2) {
      return (
        <VStack width="100%">
          <Field.ButtonGroups
            items={조문객예상인원_LIST}
            value={selectedOption.조문객수}
            onChange={(e) => {
              setSelectedOption({ 조문객수: e });

              customEvent({
                newGtm: {
                  path: "parlor_match_request",
                  trigger_and_target: "condolers-answer",
                },
              });
              customEvent({
                hackle: {
                  key: HackleEventName["견적 요청 - 조문객 수 선택"],
                  properties: { name: String(e) },
                },
              });
            }}
            borderColor="white"
            buttonWidth="100%"
          />
        </VStack>
      );
    } else if (currentStep === 3) {
      return (
        <VStack width="100%" minWidth="100%">
          <Field.ButtonGroups
            items={빈소평형_LIST as string[]}
            value={selectedOption.평형}
            onChange={(e) => {
              setSelectedOption({ 평형: e });
              customEvent({
                newGtm: {
                  path: "parlor_detail_request",
                  trigger_and_target: "pyeong-answer",
                },
              });
            }}
            borderColor="white"
            buttonWidth="100%"
          />
        </VStack>
      );
    }
  }

  return null;
};

const StepQuestionExtraDetail = ({
  currentStep,
  variation,
}: {
  currentStep: number;
  variation: string;
}) => {
  if (!currentStep) {
    return null;
  }

  if (currentStep === 1) {
    if (variation === "A") {
      return (
        <VStack width="100%" borderRadius="6px" background={colors.warmGray100} padding="12px">
          <Box className="subtitle_14_b gray600" width="100%">
            <span className="caption_12_b gray500">
              * 빈소 상황에 따라 가능한 경우 50%이상 빈소 할인까지 가능합니다.
            </span>
          </Box>
        </VStack>
      );
    } else {
      return (
        <VStack width="100%" borderRadius="6px" background={colors.warmGray100} padding="12px">
          <Box width="100%" className="body_14_m gray800" pb="36px">
            장례 비용 뿐만 아니라 전반적인 장례 절차, 임종접수, 긴급한 문의가 있으시면 부담없이
            전화나 채팅으로 연락주세요.
          </Box>
          <HStack width="100%">
            <Button
              flexGrow={1}
              style={{
                borderRadius: 6,
                backgroundColor: colors.gray800,
                padding: "6px 14px",
                boxShadow: "2px 2px 2px #00000022",
              }}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_match_request",
                    trigger_and_target: "quick_cnslt-opn_urgnt_mdl",
                  },
                });
                call("1666-9784");
              }}
            >
              <HStack alignItems="center" justifyContent="center" gap={1}>
                <ColorIcon name="icon-call-mono" color={colors.white} width={12} height={12} />
                <div className="caption_12_sb white">전화 상담</div>{" "}
              </HStack>
            </Button>
            <Button
              flexGrow={1}
              style={{
                borderRadius: 8,
                backgroundColor: colors.gray800,
                padding: "6px 14px",
                boxShadow: "2px 2px 2px #00000022",
              }}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_match_request",
                    trigger_and_target: "chat",
                  },
                });
                window.open("http://pf.kakao.com/_xgFDaK/chat");
              }}
            >
              <HStack alignItems="center" justifyContent="center" gap={1}>
                <ColorIcon name="chat_bubble_rounded" color={colors.white} width={12} height={12} />
                <div className="caption_12_sb white">채팅 상담</div>{" "}
              </HStack>
            </Button>
          </HStack>
        </VStack>
      );
    }
  } else if (currentStep === 2) {
    return (
      <VStack width="100%" borderRadius="6px" background={colors.warmGray100} padding="12px">
        <Box className="subtitle_14_b gray600" width="100%">
          <span className="caption_12_b gray500">
            조문객 수에 따라 전체 장례 비용을 예상할 수 있어요.
          </span>
        </Box>
      </VStack>
    );
  } else if (currentStep === 3) {
    if (variation === "A") {
      return (
        <VStack width="100%" borderRadius="6px" background={colors.warmGray100} padding="12px">
          <Box width="100%" className="body_14_m gray800" pb="36px">
            장례 비용 뿐만 아니라 전반적인 장례 절차, 임종접수, 긴급한 문의가 있으시면 부담없이
            전화나 채팅으로 연락주세요.
          </Box>
          <HStack width="100%">
            <Button
              flexGrow={1}
              style={{
                borderRadius: 6,
                backgroundColor: colors.gray800,
                padding: "6px 14px",
                boxShadow: "2px 2px 2px #00000022",
              }}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_match_request",
                    trigger_and_target: "quick_cnslt-opn_urgnt_mdl",
                  },
                });
                call("1666-9784");
              }}
            >
              <HStack alignItems="center" justifyContent="center" gap={1}>
                <ColorIcon name="icon-call-mono" color={colors.white} width={12} height={12} />
                <div className="caption_12_sb white">전화 상담</div>{" "}
              </HStack>
            </Button>
            <Button
              flexGrow={1}
              style={{
                borderRadius: 8,
                backgroundColor: colors.gray800,
                padding: "6px 14px",
                boxShadow: "2px 2px 2px #00000022",
              }}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_match_request",
                    trigger_and_target: "chat",
                  },
                });
                window.open("http://pf.kakao.com/_xgFDaK/chat");
              }}
            >
              <HStack alignItems="center" justifyContent="center" gap={1}>
                <ColorIcon name="chat_bubble_rounded" color={colors.white} width={12} height={12} />
                <div className="caption_12_sb white">채팅 상담</div>{" "}
              </HStack>
            </Button>
          </HStack>
        </VStack>
      );
    } else {
      return (
        <VStack width="100%" borderRadius="6px" background={colors.warmGray100} padding="12px">
          <Box className="subtitle_14_b gray600" width="100%">
            <span className="caption_12_b gray500">
              * 빈소 상황에 따라 가능한 경우 50%이상 빈소 할인까지 가능합니다.
            </span>
          </Box>
        </VStack>
      );
    }
  } else return null;
};

const StepIndicator = ({ steps, currentStep }: { steps: any[]; currentStep: number }) => {
  return (
    <HStack width="100%" alignItems="center" justifyContent="center" gap={1} paddingRight="6px">
      {steps.map((step, index) => {
        return (
          <Box
            key={step}
            width="10px"
            height="10px"
            borderRadius="50%"
            backgroundColor={currentStep === index + 1 ? colors.gray900 : colors.gray400}
          ></Box>
        );
      })}
    </HStack>
  );
};

const HeaderLayout = ({ title = "장례 비용 알아보기" }: { title: string }) => {
  return (
    <>
      <VStack gap="10px" padding="24px 0 0" width="100%">
        <HStack alignItems="center" justifyContent="center">
          <Box className="subtitle_18_b gray600" whiteSpace="pre" textAlign="center">
            {title}
          </Box>
          {/* <VStack gap={10}>
            <Button
              style={{
                borderRadius: 16,
                backgroundColor: colors.orange100,
                padding: "6px 14px",
                boxShadow: "2px 2px 2px #00000022",
              }}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "match_request",
                    trigger_and_target: "quick_cnslt-opn_urgnt_mdl",
                  },
                });
                onOpen();
              }}
            >
              <HStack alignItems="center" gap={10}>
                <ColorIcon name="icon-call-mono" color={colors.orange650} width={12} height={12} />
                <div className="caption_12_sb orange700">빠른 상담</div>{" "}
                <ColorIcon name="icon-arrow-right-small-mono" color={colors.orange700} size={8} />
              </HStack>
            </Button>
          </VStack> */}
        </HStack>
      </VStack>
    </>
  );
};
